// Etiqueta de moneda cliente-facing para render en PDF (twin BE), portal V2,
// preview. Mismo mapeo que taxticbackend/src/utils/monedaCliente.js -- mantener
// sincronizados al modificar.

export const ETIQUETAS_CLIENTE = {
  PESOS: "CLP",
  UF: "UF",
  DOLAR: "USD",
  EURO: "EUR",
  UTM: "UTM",
};

export function formatearMonedaCliente(moneda) {
  return ETIQUETAS_CLIENTE[moneda] || moneda;
}
